<template>
  <div
    class="col-md-12 wizard-card"
    :style="`border-left : 5px solid #${clase.color};`"
    :class="{ ignored: isClassIgnored }"
  >
    <div class="class-picture" style="flex-grow: 0; flex-shrink: 0">
      <div :style="`background : #${clase.color}`">
        <img :src="clase.image | s3url" />
      </div>
    </div>
    <div style="width: calc(100% - 100px)">
      <div class="row main-information" @click="onLoadDetail">
        <div class="col-md-3">
          <div>
            <b>{{ clase.name }}</b>
          </div>
          <div>{{ clase.gradeName }}</div>
          <div>
            {{ clase.groupName }} ({{
              clase.isMultiGroup ? "multigrupo" : "grupo único"
            }})
          </div>
        </div>
        <div class="col-md-2">
          <div class="section-title">
            <b>Alumnos</b>
            <i
              class="fa"
              :class="
                clase.countStudents > 0 || clase.countStudentsAssociated > 0
                  ? ICON_SUCCESS
                  : ICON_WARNING
              "
            ></i>
          </div>
          <div>Actual: {{ clase.countStudentsAssociated }}</div>
          <div>Después: {{ studentsAfterProcessing }}</div>
        </div>
        <div class="col-md-2">
          <div class="section-title">
            <b>Coach(es)</b>
            <i
              class="fa"
              :class="
                clase.hasCoachesSameLevelGradeGroupPathway
                  ? ICON_SUCCESS
                  : clase.countCoachesAssociated > 0
                  ? ICON_SUCCESS
                  : ICON_WARNING
              "
            ></i>
          </div>
          <div>Actual: {{ clase.countCoachesAssociated }}</div>
          <div>Después: {{ coachesAfterProcessing }}</div>
        </div>
        <div class="col-md-2">
          <div class="section-title">
            <b>Coordinador(es)</b>
            <i
              class="fa"
              :class="
                clase.hasCoordinatorsSameLevelGradeGroupPathway
                  ? ICON_SUCCESS
                  : clase.countCoordinatorsAssociated > 0
                  ? ICON_SUCCESS
                  : ICON_WARNING
              "
            ></i>
          </div>
          <div>Actual: {{ clase.countCoordinatorsAssociated }}</div>
          <div>Después: {{ coordinatorsAfterProcessing }}</div>
        </div>
        <div class="col-md-3 action-buttons">
          <button
            class="btn btn-outline btn-primary form-control"
            v-if="!isClassIgnored"
            @click.stop="onToggleClassWizardStatus"
            type="button"
          >
            Ignorar
          </button>
          <button
            class="btn btn-primary form-control"
            v-else
            type="button"
            @click.stop="onToggleClassWizardStatus"
          >
            Incluir
          </button>
          <button
            class="btn btn-primary form-control"
            @click.stop="onProcessClass"
            type="button"
            :disabled="shouldDisabledProcessButton"
          >
            Procesar
          </button>
        </div>
      </div>
      <div class="detail-information" v-if="displayDetails">
        <hr />
        <div class="row">
          <div class="col-md-6">
            <div class="toggle-list">
              <span
                class="title"
                @click="isOpenStudentList = !isOpenStudentList"
                ><b>Alumnos asociados <i class="fa fa-angle-right"></i></b
              ></span>
              <div class="list" v-if="isOpenStudentList">
                <div
                  class="checkbox checkbox-custom checkbox-primary"
                  v-for="student in detail.studentsAssociated"
                  :key="student.idUser_int"
                >
                  <input type="checkbox" disabled :checked="true" />
                  <label>{{ student.fullName }}</label>
                </div>
                <div v-if="detail.studentsAssociated.length == 0" class="empty">
                  No se han asociado alumnos
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="toggle-list">
              <span
                class="title"
                @click="isOpenStudentList = !isOpenStudentList"
                ><b>Alumnos <i class="fa fa-angle-right"></i></b
              ></span>
              <div class="list" v-if="isOpenStudentList">
                <div
                  class="checkbox checkbox-custom checkbox-primary"
                  v-for="student in detail.students"
                  :key="student.idUser_int"
                >
                  <input
                    type="checkbox"
                    v-model="selectedStudents"
                    :value="student.idUser"
                  />
                  <label>{{ student.fullName }}</label>
                </div>
                <div v-if="detail.students.length == 0" class="empty">
                  No se encontraron alumnos que coincidan con la clase
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--STUDENTS LIST-->
        <div class="row">
          <div class="col-md-6">
            <div class="toggle-list">
              <span class="title" @click="isOpenCoachList = !isOpenCoachList"
                ><b>Coach(es) Asociado(s) <i class="fa fa-angle-right"></i></b
              ></span>
              <div class="list" v-if="isOpenCoachList">
                <span
                  v-if="titularCoach"
                  style="font-size: 12px; font-weight: 400; color: #aaa"
                  >Titular</span
                >
                <div
                  v-if="titularCoach"
                  class="checkbox checkbox-custom checkbox-primary"
                >
                  <input type="checkbox" disabled :checked="true" />
                  <label>{{ titularCoach.fullName }}</label>
                </div>
                <span style="font-size: 12px; font-weight: 400; color: #aaa"
                  >Coach(es)</span
                >
                <div
                  class="checkbox checkbox-custom checkbox-primary"
                  v-for="coach in detail.coachesAssociated"
                  :key="coach.idUser_int"
                >
                  <input type="checkbox" disabled :checked="true" />
                  <label>{{ coach.fullName }}</label>
                </div>
                <div v-if="detail.coachesAssociated.length == 0" class="empty">
                  No se han asociado coaches
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="toggle-list">
              <span class="title" @click="isOpenCoachList = !isOpenCoachList"
                ><b>Coach(es) <i class="fa fa-angle-right"></i></b
              ></span>
              <div class="list" v-if="isOpenCoachList">
                <div
                  class="checkbox checkbox-custom checkbox-primary"
                  v-for="coach in detail.coaches"
                  :key="coach.idUser_int"
                >
                  <input
                    type="checkbox"
                    v-model="selectedCoaches"
                    :value="coach.idUser"
                  />
                  <label>{{ coach.fullName }}</label>
                </div>
                <div v-if="detail.coaches.length == 0" class="empty">
                  No se encontraron coaches que coincidan con la clase
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--COACHES LIST-->
        <div class="row">
          <div class="col-md-6">
            <div class="toggle-list">
              <span
                class="title"
                @click="isOpenCoordinatorList = !isOpenCoordinatorList"
                ><b
                  >Coordinador(es) Asociado(s)
                  <i class="fa fa-angle-right"></i></b
              ></span>
              <div class="list" v-if="isOpenCoordinatorList">
                <div
                  class="checkbox checkbox-custom checkbox-primary"
                  v-for="coordinator in detail.coordinatorsAssociated"
                  :key="coordinator.idUser_int"
                >
                  <input type="checkbox" disabled :checked="true" />
                  <label>{{ coordinator.fullName }}</label>
                </div>
                <div
                  v-if="detail.coordinatorsAssociated.length == 0"
                  class="empty"
                >
                  No se han asociado coordinadores
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="toggle-list">
              <span
                class="title"
                @click="isOpenCoordinatorList = !isOpenCoordinatorList"
                ><b>Coordinador(es) <i class="fa fa-angle-right"></i></b
              ></span>
              <div class="list" v-if="isOpenCoordinatorList">
                <div
                  class="checkbox checkbox-custom checkbox-primary"
                  v-for="coordinator in detail.coordinators"
                  :key="coordinator.idUser_int"
                >
                  <input
                    type="checkbox"
                    v-model="selectedCoordinators"
                    :value="coordinator.idUser"
                  />
                  <label>{{ coordinator.fullName }}</label>
                </div>
                <div v-if="detail.coordinators.length == 0" class="empty">
                  No se encontraron coordinadores que coincidan con la clase
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--COORDINATORS LIST-->
        <div class="row text-right">
          <div class="col-md-12 action-buttons">
            <button
              class="btn btn-primary"
              @click="onProcessClass"
              style="margin-right: 8px"
              type="button"
              :disabled="isClassIgnored"
            >
              Procesar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["clase", "areInactiveClasses"],
  data() {
    return {
      detail: null,
      displayDetails: false,
      ICON_SUCCESS: "fa-check-circle fa-green",
      ICON_WARNING: "fa-exclamation-triangle fa-yellow",
      isOpenStudentList: false,
      isOpenCoachList: false,
      isOpenCoordinatorList: false,

      titularCoach: null,

      selectedStudents: [],
      selectedCoaches: [],
      selectedCoordinators: [],
    };
  },
  computed: {
    isClassIgnored() {
      return this.clase.classStatusName == "Ignorada";
    },
    studentsAfterProcessing() {
      return this.detail
        ? this.clase.countStudentsAssociated + this.selectedStudents.length
        : this.clase.isMultiGroup
        ? this.clase.countStudents + this.clase.countStudentsAssociated
        : this.clase.countStudents;
    },
    coachesAfterProcessing() {
      return this.detail
        ? this.clase.countCoachesAssociated + this.selectedCoaches.length
        : this.clase.hasCoachesSameLevelGradeGroupPathway
        ? this.clase.countCoachesAssociated + this.clase.countCoach
        : this.clase.countCoachesAssociated;
    },
    coordinatorsAfterProcessing() {
      return this.detail
        ? this.clase.countCoordinatorsAssociated +
            this.selectedCoordinators.length
        : this.clase.hasCoordinatorsSameLevelGradeGroupPathway
        ? this.clase.countCoordinatorsAssociated + this.clase.countCoordinator
        : this.clase.countCoordinatorsAssociated;
    },
    shouldDisabledProcessButton() {
      return (
        this.isClassIgnored ||
        this.clase.classStatusName == "Procesada" ||
        this.areInactiveClasses
      );
    },
  },
  methods: {
    onLoadDetail() {
      if (this.detail) {
        this.displayDetails = !this.displayDetails;
        return;
      } else {
        this.getDetail().then(() => {
          this.displayDetails = true;
        });
      }
    },
    getDetail() {
      return new Promise((resolve) => {
        this.$depAPI.classes
          .getWizardDetail(this.clase.idClass)
          .then((response) => {
            this.detail = response.data;

            this.titularCoach = this.detail.coachesAssociated.find((el) => {
              return el.isTitular == 1;
            });
            this.detail.coachesAssociated =
              this.detail.coachesAssociated.filter((el) => {
                return el.isTitular != 1;
              });

            this.selectedStudents = this.detail.students.map((el) => el.idUser);
            if (this.clase.hasCoachesSameLevelGradeGroupPathway)
              this.selectedCoaches = this.detail.coaches.map((el) => el.idUser);

            if (this.clase.hasCoordinatorsSameLevelGradeGroupPathway)
              this.selectedCoordinators = this.detail.coordinators.map(
                (el) => el.idUser
              );

            resolve();
          });
      });
    },
    onProcessClass() {
      if (!this.detail) {
        this.getDetail().then(() => {
          this.makeProcessing();
        });
      } else {
        this.makeProcessing();
      }
    },
    makeProcessing() {
      this.$depAPI.classes
        .processClassInWizard({
          idClass: this.clase.idClass,
          idsCoaches: this.selectedCoaches,
          idsStudents: this.selectedStudents,
          idsCoordinators: this.selectedCoordinators,
        })
        .then(() => {
          this.$toast.success({ title: "La clase se procesó correctamente" });
          this.$parent.$parent.refreshData();
        });
    },
    onToggleClassWizardStatus() {
      this.$depAPI.classes.ignoreClassInWizard(this.clase.idClass).then(() => {
        this.$toast.success({
          title: "El estatus de la clase ha sido cambiado",
        });
        this.$parent.$parent.refreshData();
      });
    },
  },
};
</script>

<style lang="scss">
.wizard-card {
  border: 1px solid #ddd;
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
  margin-bottom: 0.4vw;

  display: flex;
  align-items: flex-start;

  padding: 15px;

  &.ignored {
    background: rgba(245, 245, 245, 0.8);
  }

  .class-picture {
    > div {
      width: 6.5vw;
      height: 6.5vw;
      max-width: 80px;
      max-height: 80px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 100%;
      margin-right: 8px;
    }
    img {
      width: 100%;
      object-fit: contain;
    }
  }

  .fa-green {
    color: green;
    margin-left: 3px;
  }

  .fa-yellow {
    color: #ffcc00;
    margin-left: 3px;
  }

  .action-buttons {
    .btn {
      margin: 5px 0;
      min-width: 130px;
      max-width: 130px;
    }
  }

  .section-title {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
.toggle-list {
  .title {
    cursor: pointer;
  }

  .empty {
    color: #9d9d9d;
  }
}
</style>
